export const GAS_TYPE: any = {
  CO2: 'CO₂',
  CH4: 'CH₄',
  N2O: 'N₂O',
  HFCs: 'HFCs',
  PFCs: 'PFCs',
  SF6: 'SF₆',
  NF3: 'NF₃',
  // CO2b: 'Bio-CO₂',
  ['CO2(生質)']: 'CO₂(生質)',
}
